import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'barrierHeight'
})
export class BarrierHeightPipe implements PipeTransform {
    types = {
        '0.5-1m': '0.5m - 1.0m',
        '1-2m': '1.0m - 2.0m',
        '2-5m': '2.0m - 5.0m',
        '5-10m': '5.0m - 10.0m',
        'gt10m': 'Greater than 10.0m',
        'lt0.5m': 'Less than 0.5m',
        'not_specified': 'Not specified'
    };

    transform(value: string) {
        if (this.types.hasOwnProperty(value)) {
            return this.types[value];
        } else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/barrier-height.pipe.ts